import { JSX } from 'react';
export const PhoneIcon = ({
  fill = '#1c49c2',
}: {
  fill?: string;
}): JSX.Element => {
  return (
    <svg
      className="icon__phone"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      data-a11y="decorative"
    >
      <path
        d="M16.025 12.7167L13.9083 12.475C13.4 12.4167 12.9 12.5917 12.5417 12.95L11.0083 14.4833C8.65 13.2833 6.71667 11.3583 5.51667 8.99167L7.05834 7.45C7.41667 7.09166 7.59167 6.59167 7.53334 6.08333L7.29167 3.98333C7.19167 3.14166 6.48334 2.50833 5.63334 2.50833H4.19167C3.25 2.50833 2.46667 3.29166 2.525 4.23333C2.96667 11.35 8.65834 17.0333 15.7667 17.475C16.7083 17.5333 17.4917 16.75 17.4917 15.8083V14.3667C17.5 13.525 16.8667 12.8167 16.025 12.7167Z"
        fill={fill}
      />
    </svg>
  );
};
